import {words} from 'lodash'

export default {
  methods: {
    validateEmail (mail) {
      const result = []
      const recipients = words(mail, /[^, |\s]+/g)
      const reg = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/gmi
      recipients.forEach(address => {
        reg.lastIndex = 0
        result.push(reg.test(address))
      })
      return result.every(item => item)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/validateEmail.js